const state = {
  nowTypeSet: localStorage.getItem('typeSet') || 0,
  nowExamid: localStorage.getItem('examid') || undefined,
  btnPermis: localStorage.getItem('btnPermis') || undefined
}

const getters = {
  typeset: (state) => {
    return state.nowTypeSet
  },
  examid: (state) => {
    return state.nowExamid
  },
  btnPermis: (state) => {
    return state.btnPermis
  },
}

const mutations = {
  setNowTypeSet: (state, typeSet) => {
    state.nowTypeSet = typeSet
  },
  setNowExamid: (state, typeSet) => {
    state.nowExamid = typeSet
  },
  setBtnPermis: (state, typeSet) => {
    state.btnPermis = typeSet
  },
}

const actions = {
  setNowTypeSet({ commit }, typeSet) {
    commit('setNowTypeSet', typeSet)
    localStorage.setItem('typeSet', typeSet)
  },
  setNowExamid({ commit }, examid) {
    commit('setNowExamid', examid)
    localStorage.setItem('examid', examid)
  },
  setBtnPermis({ commit }, btnPermis) {
    commit('setBtnPermis',  JSON.stringify(btnPermis))
    localStorage.setItem('btnPermis', JSON.stringify(btnPermis))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
